import React from 'react';
import styles from './EditClinicalDecisionSupportAlertFloating.module.css';
import { Box, Checkbox, makeStyles } from '@material-ui/core';
import { ValidDateFormats, ValidTimeFormats } from '../../Shared/DateUtilities';
import moment from 'moment';
import { white } from '../../Styles/Colours';
var useStyles = makeStyles({
    root: {
        padding: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: 1,
        width: 18,
        height: 18,
        backgroundColor: white,
        WebkitBoxShadow: "0px 0px 0px 1.25px rgba(0,0,0)",
        boxShadow: "0px 0px 0px 1.25px rgba(0,0,0)",
    },
    checkedIcon: {
        backgroundColor: white,
        WebkitBoxShadow: "none",
        boxShadow: "none",
        '&:before': {
            display: 'block',
            width: 18,
            height: 18,
            background: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' viewBox='-10 -10 64.56 64.56'%3E%3Cpath d='M23.297 38.74a6.563 6.563 0 0 1-10.16.499L1.308 26.112a5.083 5.083 0 1 1 7.551-6.805l8.369 9.288a.617.617 0 0 0 .956-.047L35.386 5.217a5.083 5.083 0 1 1 8.181 6.032L23.297 38.74z' fill='%23D93923' /%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {},
    },
    statusLabel: { fontWeight: 600, marginLeft: 8, fontSize: '12px' }
});
export var EditClinicalDecisionSupportAlertFloating = function (props) {
    var _a, _b;
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.positioner },
            React.createElement("div", { className: styles.container },
                React.createElement(Box, { className: styles.statusBadge + " " + styles.criticalBadge },
                    React.createElement(Box, { className: styles.inline },
                        React.createElement(Checkbox, { className: classes.root, checked: true, disableRipple: true, color: "default", checkedIcon: React.createElement("span", { className: classes.icon + " " + classes.checkedIcon }), icon: React.createElement("span", { className: classes.icon }) }),
                        React.createElement("span", { className: classes.statusLabel }, 'Alerts noted'))),
                React.createElement("div", { className: styles.content },
                    React.createElement("div", null,
                        "Noted by ",
                        React.createElement("span", { className: styles.contentBold }, (_a = props.patientMedication.cdsDetail.notedBy) === null || _a === void 0 ? void 0 :
                            _a.givenName,
                            " ",
                            ' ', (_b = props.patientMedication.cdsDetail.notedBy) === null || _b === void 0 ? void 0 :
                            _b.familyName)),
                    React.createElement("div", null,
                        "at ",
                        React.createElement("span", { className: styles.contentBold }, moment(props.patientMedication.cdsDetail.notedOn, ValidDateFormats.NodeDateTimeTimezone).format(ValidTimeFormats.Format24HR)),
                        " on ",
                        ' ',
                        React.createElement("span", { className: styles.contentBold }, moment(props.patientMedication.cdsDetail.notedOn, ValidDateFormats.IsoFormat).format(ValidDateFormats.DisplayWithHyphen)),
                        "."))))));
};
